import { render, staticRenderFns } from "./serveDetail.vue?vue&type=template&id=80bdd4d2&scoped=true&"
import script from "./serveDetail.vue?vue&type=script&lang=js&"
export * from "./serveDetail.vue?vue&type=script&lang=js&"
import style0 from "./serveDetail.vue?vue&type=style&index=0&id=80bdd4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bdd4d2",
  null
  
)

export default component.exports